import React, { useContext } from "react";

import { HtmlSelect } from "../../../../components/form-components/FormField/SelectInput/Html";

import CameraFilterContext from "../../CameraListing/CameraFilterContext";

import t from "../../../../lib/translate";

import * as styles from "./sortSelect.module.less";

export function SortSelect() {
    const { sortBy, sortAction } = useContext(CameraFilterContext);
    return (
        <div className={styles.sortWrapper}>
            <span>{t`camera.filter.sort.label`}</span>
            <HtmlSelect
                value={sortBy.active}
                options={sortBy.options.map(({ value, labelTranslation }) => ({
                    value,
                    label: t(labelTranslation)
                }))}
                onChange={(e) => sortAction(e.target.value)}
            />
        </div>
    );
}
